Promise.all([import(/* webpackMode: "eager" */ './footer.scss'), import('../subscribe/subscribe'), import('../../plugins/semantic/modal'),
import('../../plugins/semantic/modal.scss'),]).then(() => {
  $('.widget.footer').each(function (i, el) {
    $(el).data('widget', new Footer(el))
    $(el).data('widget').init()
  })
})

function Footer(el) {
  const self = this
  self.el = $(el)
  console.log(self.el)
  const isMobileLargeMax = window.matchMedia('(max-width: 767px)')
  const locations = {}
  const handleLocations = function (e) {
    if (e.matches) {
      locations.headings.removeClass('active') // clean up
      locations.lists.hide().removeClass('is-open') // clean up

      locations.headings.on('click', function (e) {
        e.preventDefault() // stops link navigation
        const thisHeading = $(this)
        const thisList = $(this).next()

        // collapse the 'clicked' lists if its already revealed
        if (thisHeading.hasClass('active')) {
          thisHeading.removeClass('active')
          thisList.stop().slideUp().removeClass('show')
          return
        }

        // collapse all lists
        locations.headings.removeClass('active')
        locations.lists.stop().slideUp().removeClass('show')

        // reveal the 'clicked' lists
        thisHeading.addClass('active')
        thisList.stop().slideDown().addClass('show') // class manipulation needs to be last so CSS transitions work
      })
    } else {
      locations.headings
        .off() // remove click handlers
        .removeClass('active') // clean up
      locations.lists.show().removeClass('show') // clean up
    }
  }
  self.ParkHubLoginPopup = () => {

    let $parkLoginLink = null;
    $('.footer .links ul li a').each(function (k, elem) {
      if ($(elem).text().trim() == "Park Login") {
        $parkLoginLink = $(elem);
      }
    })
    if ($parkLoginLink !== null) {
      self.loginModal.find('.loginLink').attr('href', $parkLoginLink.attr('href'));
      $parkLoginLink.attr('disabled-href', $parkLoginLink.attr('href'));
      $parkLoginLink.attr('href', '#');
      $parkLoginLink.on('click', function (e) {
        e.preventDefault();
        self.loginModal.show();
        self.loginModal.modal('show');
      });

    }

  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('Footer init', self)
    }

    self.loginModal = self.el.find('.login-popup').modal();
    self.ParkHubLoginPopup();
    self.el.css('opacity', 1)

    // Handle the display of location lists
    locations.headings = self.el.find('.locations-list-heading')
    locations.lists = self.el.find('.locations-list-items')
    handleLocations(isMobileLargeMax) // runs on init
    isMobileLargeMax.addEventListener('change', handleLocations)

    // Handle the subscription form
    self.el.find('.subscribe input').on('keypress', function (e) {
      const ENTER_KEY = 13
      if (e.which === ENTER_KEY) {
        e.preventDefault()
        e.target.form.submit()
        return false
      }
    })

    //opens the cloud subscription form into another tab
    //comments out this part of code to fix issue in CW20-1246
    //self.el.find('.widget.subscribe a').click(function (e) {
    //  let baseUrl = window.location.origin
    //  window.open(baseUrl + "/subscriber", "_blank")
    //})
  }
}
